import React from 'react';
import $ from 'jquery';
import CloseButton from '../../Buttons/CloseButton';
import { AccountList, FAQs } from '../../../assets/constants/strings';
import './style.scoped.scss';

const FAQModal = ({ question }) => {
  const FAQ = FAQs.filter((faq) => faq.NUMBER === question)[0];
  const FAQAccount = AccountList.filter(
    (account) => account.NUMBER === question
  )[0];
  return (
    <div>
      <div
        className='modal help'
        id='FAQModal'
        data-backdrop='static'
        data-keyboard='false'
      >
        <div className='modal-lg'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h1>Frequently Asked Questions</h1>

              <CloseButton
                title='Dismiss Modal'
                handleClose={() => $('#FAQModal').modal('hide')}
              />
            </div>
            <h2 className='p-3 text-center'>
              {(FAQ && FAQ.TITLE) || (FAQAccount && FAQAccount.TITLE)}
            </h2>
            {(FAQ && FAQ.CONTENT) || (FAQAccount && FAQAccount.CONTENT)}
          </div>
        </div>
      </div>

      <div
        className='modal image-modal'
        id='imageModal'
        data-backdrop='static'
        data-keyboard='false'
      >
        <div className='modal-dialog modal-dialog-centered modal-xl'>
          <div className='modal-content'>
            <div className='w-100'>
              <CloseButton
                title='Dismiss Modal'
                handleClose={() => {
                  $('#imageModal').modal('hide');
                  $('#FAQModal').modal('show');
                  $('.modal-backdrop').appendTo('#wf-doc-page');
                }}
              />
              <img className='w-100 h-100 mt-4' id='selectedImage' alt='FAQ' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQModal;
